import { classes } from "../../nucleo/classes";
import type { SecaoDaImplantacao } from "../../nucleo/secoesDaImplantacao";

export interface CardDaSecao {
  id: SecaoDaImplantacao;
  titulo: string;
  /* `null` enquanto o dado carrega: o card mostra "—", nunca um zero que ainda não é verdade. */
  resumo: string | null;
  alerta?: string | null;
}

/**
 * Os cards de navegação da tela da implantação (SUS-15400): um por seção, com o resumo do que
 * há nela. O clique abre só aquela seção no painel abaixo; o card aberto fica marcado e a seção
 * vai para o hash da URL. São botões com `aria-pressed`, e não abas, porque cada card leva a um
 * endereço próprio que se compartilha.
 */
export function NavegacaoDaImplantacao({
  cards,
  ativa,
  aoAbrir,
}: {
  cards: readonly CardDaSecao[];
  ativa: SecaoDaImplantacao;
  aoAbrir: (secao: SecaoDaImplantacao) => void;
}) {
  return (
    <nav className="secoes-da-implantacao" aria-label="Seções da implantação" data-testid="secoes-da-implantacao">
      {cards.map((card) => (
        <button
          key={card.id}
          type="button"
          className={classes("secao-da-implantacao", card.id === ativa && "secao-da-implantacao--ativa")}
          aria-pressed={card.id === ativa}
          data-testid={`card-${card.id}`}
          onClick={() => aoAbrir(card.id)}
        >
          <span className="secao-da-implantacao__titulo">{card.titulo}</span>
          <span className="secao-da-implantacao__resumo">{card.resumo ?? "—"}</span>
          {card.alerta ? (
            <span className="secao-da-implantacao__alerta" data-testid={`alerta-${card.id}`}>
              {card.alerta}
            </span>
          ) : null}
        </button>
      ))}
    </nav>
  );
}
